define("Tavanoteam.UpsellAddToCartModal.UpsellAddToCartModal", [
  "Tavanoteam.UpsellAddToCartModal.UpsellAddToCartModal.View",
], function (UpsellAddToCartModalView) {
  "use strict";

  return {
    mountToApp: function mountToApp(container) {
      // using the 'Layout' component we add a new child view inside the 'Header' existing view
      // (there will be a DOM element with the HTML attribute data-view="Header.Logo")
      // more documentation of the Extensibility API in
      // https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html

      /** @type {LayoutComponent} */
      var layout = container.getComponent("Layout");
      var pdp = container.getComponent("PDP");

      if (layout && pdp) {
        var item = pdp.getItemInfo();
        //Adds the view to the confirmation cart modal
        layout.addChildView("Child.View", function () {
          if (container.getLayout().getCurrentView().model) {
            var item = container.getLayout().getCurrentView().model.getItem();
            return new UpsellAddToCartModalView({
              container: container,
              item: item,
            });
          }
        });
      }
    },
  };
});
